import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';
import { tableColumnDefinitionsWithSelection } from '@antimatterhq/ui/utils/table/helpers';

const baseDefinitions: TableColumnDefinition[] = [
  {
    id: 'eventTime',
    title: 'Event time',
    width: 150,
  },
  {
    id: 'resourceType',
    title: 'Resource type',
    width: 150,
  },
  {
    id: 'resourceName',
    title: 'Resource name',
    width: 200,
  },
  {
    id: 'duplicates',
    title: 'Duplicates',
    width: 75,
  },
  {
    id: 'summary',
    title: 'Summary',
    width: 150,
  },
  {
    id: 'details',
    title: 'Details',
    width: 200,
  },
  {
    id: 'state',
    title: 'State',
    tooltip: false,
    width: 100,
  },
  {
    id: 'edit',
    title: '',
    tooltip: false,
    width: 32,
    enableFiltering: false,
    enableSorting: false,
    enableResize: false,
    pinned: 'right',
  },
];

export const healthTableColumnDefinitions =
  tableColumnDefinitionsWithSelection(baseDefinitions);
